/**
 * Longest-edge fit for a task photo. The canvas step uses this size
 * before it writes a JPEG. No object spread.
 */

const TASK_PHOTO_MAX_EDGE = 1600;
const TASK_PHOTO_QUALITY = 0.82;

function fittedSize(width, height, maxEdge) {
  const edgeLimit = maxEdge || TASK_PHOTO_MAX_EDGE;
  const w = Math.round(Number(width) || 0);
  const h = Math.round(Number(height) || 0);
  if (w < 1 || h < 1 || edgeLimit < 1) return null;
  const longest = Math.max(w, h);
  if (longest <= edgeLimit) return { width: w, height: h };
  const scale = edgeLimit / longest;
  return {
    width: Math.max(1, Math.round(w * scale)),
    height: Math.max(1, Math.round(h * scale)),
  };
}

module.exports = {
  TASK_PHOTO_MAX_EDGE,
  TASK_PHOTO_QUALITY,
  fittedSize,
};
